import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useStreamSocket, useSocketReconnectCallback } from '@reflex/ui/client/socket';
import { deduplicateEvents } from '@reflex/ui/client/event-utils';
import type { AxonEvent } from '@reflex/shared';
import { getAxonEvents } from './api';

export function useAxonStreamSocket(axonId: string | null): void {
  const queryClient = useQueryClient();

  useStreamSocket({
    streamId: axonId,
    queryKey: ['axon-events', axonId],
  });

  const reconcileStream = useCallback(() => {
    if (!axonId) return;

    getAxonEvents(axonId)
      .then((events: AxonEvent[]) => {
        // Server snapshot first so a backfilled event keeps its place in the
        // timeline instead of being appended after events that follow it.
        queryClient.setQueryData<AxonEvent[]>(['axon-events', axonId], (old) =>
          deduplicateEvents([...events, ...(old ?? [])]),
        );
      })
      .catch(() => {
        // reconciliation failure is non-fatal; next events will arrive via WS
      });
  }, [axonId, queryClient]);
  useSocketReconnectCallback(reconcileStream);
}
